import { render } from "./DocumentActionsBar.vue?vue&type=template&id=874f7f4a&scoped=true"
import script from "./DocumentActionsBar.vue?vue&type=script&lang=js"
export * from "./DocumentActionsBar.vue?vue&type=script&lang=js"

import "./DocumentActionsBar.vue?vue&type=style&index=0&id=874f7f4a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-874f7f4a"]])

export default __exports__